import React from "react"
import {useNavigate} from "react-router-dom"
import classNames from "classnames"
import {startCase} from "lodash"
import moment from "moment"
import numeral from "numeral"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import {Meta} from "../../resources/common"
import {PaymentIntent, IntentStatus} from "../../resources/intents"

function intentStatusClass(status: string): string {
	switch (status) {
		case IntentStatus.Approved:
		case IntentStatus.Completed:
			return "status-success"
		case IntentStatus.Processing:
			return "status-pending"
		case IntentStatus.Declined:
		case IntentStatus.Failed:
		case IntentStatus.Cancelled:
			return "status-danger"
		default:
			return "status-neutral"
	}
}

interface ManagedSolutionsIntentsTableProps {
	intents: PaymentIntent[]
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	fullHeight?: boolean
	meta?: Meta
	sortFunction: () => void
	sortBy: string
}

export default function ManagedSolutionsIntentsTable({
	intents,
	hasPrev,
	hasNext,
	prev,
	next,
	hasResults,
	isUsingPaging,
	fullHeight,
	meta,
	sortFunction,
	sortBy,
}: ManagedSolutionsIntentsTableProps) {
	const navigate = useNavigate()
	const noContent = intents.length === 0

	return (
		<div className="managed-solutions-intents-table">
			<DataTable isEmpty={noContent} fullHeight={fullHeight} noContentText="No intents yet" clickable hoverable>
				<DataTableHead className={classNames(!fullHeight && "no-sticky")}>
					<DataTableRow>
						<DataTableCell>ID</DataTableCell>
						<DataTableCell>Title</DataTableCell>
						<DataTableCell>Type</DataTableCell>
						<DataTableCell>Amount</DataTableCell>
						<DataTableCell>Status</DataTableCell>
						<DataTableCell
							clickable
							onClick={() => sortFunction()}
							sortable
							sortApplied={sortBy === "createdAt" || sortBy === "-createdAt"}
						>
							Created At
						</DataTableCell>
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{intents.map((intent) => {
						const {title, amount, paymentType, status, createdAt} = intent.attributes
						return (
							<DataTableRow key={intent.id} onClick={() => navigate(`/managed-solutions/intents/${intent.id}`)}>
								<DataTableCell className="data-table-id-cell">{intent.id}</DataTableCell>
								<DataTableCell>{title}</DataTableCell>
								<DataTableCell>{paymentType ? startCase(paymentType) : "—"}</DataTableCell>
								<DataTableCell>{numeral(amount / 100).format("$0,0.00")}</DataTableCell>
								<DataTableCell>
									<span className={classNames("status-badge", intentStatusClass(status))}>{startCase(status)}</span>
								</DataTableCell>
								<DataTableCell style={{whiteSpace: "nowrap"}}>{moment(createdAt).format("L LT")}</DataTableCell>
							</DataTableRow>
						)
					})}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
